export const GUIDE_MODAL_VISIBLE = "GUIDE_MODAL_VISIBLE";
export const GUIDE_MODAL_INVISIBLE = "GUIDE_MODAL_INVISIBLE";
export const UPDATE_SCENE = "UPDATE_SCENE";
export const UPDATE_IMAGE = "UPDATE_IMAGE";
